import React from "react";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DoneIcon from "@mui/icons-material/Done";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import ChannelBadge from "./ChannelBadge";

const senderMeta = {
  student: { label: "Student", Icon: PersonOutlineIcon },
  staff: { label: "Counsellor", Icon: SupportAgentIcon },
  ai: { label: "AI Bot", Icon: SmartToyOutlinedIcon },
  system: { label: "System", Icon: SettingsIcon },
};

function statusIcon(status) {
  if (status === "read") return <DoneAllIcon style={{ fontSize: 14, color: "#53bdeb" }} />;
  if (status === "delivered") return <DoneAllIcon style={{ fontSize: 14, color: "#94a3b8" }} />;
  if (status === "sent") return <DoneIcon style={{ fontSize: 14, color: "#94a3b8" }} />;
  if (status === "failed") return <ErrorOutlineIcon style={{ fontSize: 14, color: "#ef4444" }} />;
  return null;
}

function formatTime(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export default React.memo(function MessageBubble({ message }) {
  const isOutbound = message.sender_type !== "student";
  const isNote = message.channel === "internal";
  const meta = senderMeta[message.sender_type] || senderMeta.system;
  const SenderIcon = meta.Icon;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: isOutbound ? "flex-end" : "flex-start",
        padding: "2px 16px",
      }}
    >
      <div
        style={{
          maxWidth: "70%",
          borderRadius: 12,
          padding: "8px 12px",
          background: isNote
            ? "#fef3c7"
            : isOutbound
            ? "#dcf8c6"
            : "#ffffff",
          border: isNote ? "1px dashed #f59e0b" : "1px solid #e2e8f0",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontSize: 11,
            color: "#64748b",
            marginBottom: 2,
          }}
        >
          <ChannelBadge channel={message.channel} size={13} />
          <SenderIcon style={{ fontSize: 13 }} />
          <span>{meta.label}</span>
          {isNote && <span style={{ fontStyle: "italic" }}>(note)</span>}
        </div>

        {message.subject && (
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{message.subject}</div>
        )}

        <div style={{ fontSize: 14, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {message.content || <span style={{ color: "#94a3b8" }}>[No content]</span>}
        </div>

        {message.media_url && (
          <a
            href={message.media_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 12, color: "#2563eb" }}
          >
            View attachment
          </a>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 4,
            marginTop: 4,
            fontSize: 11,
            color: "#94a3b8",
          }}
        >
          <span>{formatTime(message.created_at)}</span>
          {isOutbound && statusIcon(message.status)}
        </div>
      </div>
    </div>
  );
});
